export default function ElectricBlanket(props: any) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="1.6" y="4.6" width="22.8" height="18.8" rx="0.998279" stroke="#757575" strokeWidth="1.2" />
            <path
                d="M4 19V10C4 9.44772 4.44772 9 5 9H6C6.55228 9 7 9.44772 7 10V18C7 18.5523 7.44772 19 8 19H9C9.55228 19 10 18.5523 10 18V10C10 9.44772 10.4477 9 11 9H12C12.5523 9 13 9.44772 13 10V18C13 18.5523 13.4477 19 14 19H15C15.5523 19 16 18.5523 16 18V10C16 9.44772 16.4477 9 17 9H18C18.5523 9 19 9.44772 19 10V18C19 18.5523 19.4477 19 20 19H21C21.5523 19 22 18.5523 22 18V9"
                stroke="#757575"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path d="M7 23V26C7 26.5523 7.44772 27 8 27H27.5C28.0523 27 28.5 26.5523 28.5 26V15" stroke="#757575" strokeWidth="1.2" />
            <rect x="26.5" y="7.5" width="4" height="7" rx="0.5" stroke="#757575" />
            <path
                d="M29.25 9.75C29.25 10.1642 28.9142 10.5 28.5 10.5C28.0858 10.5 27.75 10.1642 27.75 9.75C27.75 9.33579 28.0858 9 28.5 9C28.9142 9 29.25 9.33579 29.25 9.75Z"
                fill="#757575"
            />
            <circle cx="28.5" cy="12.5" r="0.5" fill="#757575" />
        </svg>
    );
}
